import React from "react";
import { SidebarMenuItemType } from "../../../services/helpers/types";
import { CurrentSidebarItemState } from "../../pages/MainPage/MainPage";
import SidebarSkeleton from "../../organisms/Sidebar/SidebarSkeleton";
import { useSelector } from "react-redux";
import SidebarItems from "../SidebarItems/SidebarItems";
import EditableSidebarItems from "../EditableSidebarItems/EditableSidebarItems";
import classNames from "classnames";

interface SidebarMidProps {
  sidebarItems: SidebarMenuItemType[];
  currentSidebarItem: CurrentSidebarItemState;
  isLoading: boolean;
  onPageSelect: (itemID?: number, shouldRefresh?: boolean) => void;
  onPageCreate: (itemID: number) => void;
}

const SidebarMid = (props: SidebarMidProps) => {
  const {
    sidebarItems,
    currentSidebarItem,
    isLoading,
    onPageSelect,
    onPageCreate,
  } = props;

  const isInEditMode = useSelector((state: any) => state.app.isInEditMode);

  const className = classNames("dui-sidebar-mid", {
    "dui-sidebar-mid-editable": isInEditMode,
  });

  if (isLoading) {
    return <SidebarSkeleton />;
  }
  return (
    <div className={className} id="dui-sidebar-mid">
      <div className="dui-sidebar-mid-wrapper">
        {isInEditMode ? (
          <EditableSidebarItems
            currentSidebarItem={currentSidebarItem}
            sidebarItems={sidebarItems}
            onPageSelect={onPageSelect}
            onPageCreate={onPageCreate}
          />
        ) : (
          <SidebarItems
            currentSidebarItem={currentSidebarItem}
            sidebarItems={sidebarItems}
            onPageSelect={onPageSelect}
          />
        )}
      </div>
    </div>
  );
};

export default SidebarMid;
